export enum EventType {
	SURVEY_SHOWN = 'survey_shown',
	SURVEY_DATA = 'survey_data',
	CHANNEL_OPEN = 'channel_open',
	USER_INFO = 'user_info',
	POSTBACK = 'postback',
	TYPING = 'typing',
	CHAT_MAXIMIZED = 'chat_maximized',
	CHAT_MINIMIZED = 'chat_minimized',
	WEB_MESSAGE = 'web_message'
}
